import type { FagomradeType } from './minhelseentities';

import type { SvgPathProps } from '@helsenorge/designsystem-react/components/Icon';


export enum TagGroup {
  topTags = 0,
  detailTags = 1,
}

export enum PageRoutes {
  baseUrl = '/verktoy',
  entryPage = '/',
  finnVerktoy = '/finn-verktoy',
  uthopp = '/uthopp',
  oppgave = 'oppgave',
}

export enum QueryStrings {
  fagomrade = '?Fagomrade=',
}

export enum SessionStorageKeys {
  verktoyId = 'verktoyId',
  openLenkeTypeClicked = 'openLenkeTypeClicked',
  filtersAndSorting = 'filtersAndSorting',
  returnLocation = 'returnLocation',
}

export interface CategoryCard {
  category: FagomradeType;
  title: string | undefined;
  icon: React.FC<SvgPathProps>;
}
